import { useQuery } from '@tanstack/react-query';
// Trip import — reserved for future use

const API_BASE = process.env.REACT_APP_API_BASE || '';

interface TripVisitReport {
  tripId: string;
  tripName: string;
  visitCount: number;
  startDate: string;
  endDate: string;
}

interface AttractionReportItem {
  attractionId: string;
  attractionName: string;
  parkName: string;
  count: number;
}

interface TripAttractionReport {
  tripId: string;
  tripName: string;
  attractions: AttractionReportItem[];
}

interface TripVisitCalendarItem {
  date: string;
  parks: string[];
  visitCount?: number;
  visitPeriod?: 'MORNING' | 'MIDDAY' | 'EVENING';
}

export function useTripVisitReports() {
  return useQuery({
    queryKey: ['reports', 'trip-visits'],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/api/admin/reports/trip-visits`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      return response.json() as Promise<TripVisitReport[]>;
    },
  });
}

export function useTripAttractionReports() {
  return useQuery({
    queryKey: ['reports', 'attraction-selections'],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/api/admin/reports/attraction-selections`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      return response.json() as Promise<TripAttractionReport[]>;
    },
  });
}

export function useTripVisitCalendar(tripId: string) {
  return useQuery({
    queryKey: ['reports', 'visits', tripId],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/api/admin/reports/${tripId}/visits`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      return response.json() as Promise<TripVisitCalendarItem[]>;
    },
    enabled: !!tripId,
  });
}

export function useTripAttractions(tripId: string) {
  return useQuery({
    queryKey: ['reports', 'attractions', tripId],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/api/admin/reports/${tripId}/attractions`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      const data = await response.json() as Promise<AttractionReportItem[]>;
      return data;
    },
    enabled: !!tripId,
  });
}
